import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["gradient-text", {hoverable: $props.hoverable, hover: $props.hover, horizontal: $props.horizontal, transparent: $props.transparent}])
  }, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 2 /* CLASS */))
}